import useAuthenticatedFetch from "./common/useAuthenticatedFetch";
import { useAuthenticatedApiRequest } from "./common/useAuthenticatedFetcher";
import { ApiResponse } from "./models/ApiResponse";
import {
    AddEvidenceDto,
    EvidenceHistoryResponse,
    EvidenceItem,
    EvidenceType,
    UpdatevidenceDto,
} from "./models/Evidence";

export const useEvidenceTypes = () => {
    const { response, isLoading } =
        useAuthenticatedFetch<ApiResponse<EvidenceType[]>>(
            "api/evidence-types"
        );

    return {
        evidenceTypes: response?.content ?? [],
        isLoading,
    };
};

export const useAddEvidence = () =>
    useAuthenticatedApiRequest<AddEvidenceDto, void>("POST", "api/evidence");

export const useUpdateEvidence = (id: number) =>
    useAuthenticatedApiRequest<UpdatevidenceDto, void>(
        "PUT",
        `api/evidence/${id}`
    );

export const useEvidence = () => {
    const { response, isLoading, refetch } =
        useAuthenticatedFetch<ApiResponse<EvidenceItem[]>>("api/evidence");

    return {
        evidence: response?.content ?? [],
        isLoading,
        refetch,
    };
};

export const useEmissionsSourceEvidenceHistory = (
    evidenceTypeId: number,
    emissionsSourceId: number
) => {
    const { response, isLoading, refetch } = useAuthenticatedFetch<
        ApiResponse<EvidenceHistoryResponse>
    >(
        `api/emissions-sources/${emissionsSourceId}/evidence-history/${evidenceTypeId}`
    );

    return {
        evidence: response?.content?.evidence ?? [],
        gaps: response?.content?.gaps ?? [],
        isLoading,
        refetch,
    };
};

export const useOrganizationEvidenceHistory = (evidenceTypeId: number) => {
    const { response, isLoading, refetch } = useAuthenticatedFetch<
        ApiResponse<EvidenceHistoryResponse>
    >(`api/organization-evidence-history/${evidenceTypeId}`);

    return {
        evidence: response?.content?.evidence ?? [],
        gaps: response?.content?.gaps ?? [],
        isLoading,
        refetch,
    };
};
